export default "__VITE_ASSET__aaoe0E1q__"